export const SAVE_MODEL_TYPE_REQUEST = "SAVE_MODEL_TYPE_REQUEST";
export const SAVE_MODEL_TYPE_SUCCESS = "SAVE_MODEL_TYPE_SUCCESS";
export const SAVE_MODEL_TYPE_FAILURE = "SAVE_MODEL_TYPE_FAILURE";
